import axios from 'axios';

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },
  async exportUsersXls(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/users/export`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
          responseType: 'arraybuffer',
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getUsers(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/users`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
